import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import Header from './components/Header';
import HomePage from './pages/HomePage';
import BoxSelectionPage from './pages/BoxSelectionPage';
import HistoryPage from './pages/HistoryPage';
import './styles/variables.css';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="app">
          <Header />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/play/:itemId" element={<BoxSelectionPage />} />
              <Route path="/history" element={<HistoryPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </ThemeProvider>
  );
}

const Footer = () => (
  <footer className="footer">
    <div className="footer-content">
      <div className="footer-brand">
        <span className="footer-logo">🎁</span>
        <span className="footer-name">LuckyBox</span>
      </div>
      <p className="footer-text">
        © 2024 LuckyBox Kenya. Play Responsibly. 18+ Only.
      </p>
      <div className="footer-links">
        <a href="#terms">Terms & Conditions</a>
        <a href="#privacy">Privacy Policy</a>
        <a href="#support">Support</a>
      </div>
    </div>
  </footer>
);

export default App;
